import { useState, useEffect } from "react";

type UseStorageStateReturn = [
  storageState: string | null,
  setStorageState: React.Dispatch<React.SetStateAction<string | null>>
];

function useStorageState({
  storageKey,
  initialValue,
}: {
  storageKey: string;
  initialValue?: string | null;
}): UseStorageStateReturn {
  const initialState = (initialValue ?? localStorage.getItem(storageKey) ?? null) as
    | string
    | null;

  const [storageState, setStorageState] = useState<string | null>(initialState);

  useEffect(() => {
    if (storageState === null) {
      localStorage.removeItem(storageKey);
    } else {
      localStorage.setItem(storageKey, storageState as unknown as string);
    }
  }, [storageState, storageKey]);

  return [storageState, setStorageState];
}

export default useStorageState;
